import { SkeletonLoader } from '@unified-checkout/design-system';

import styles from './StaticsBoxes.module.scss';

const StaticsBoxes = ({
  isLoading,
  campaignStaticsList,
}: {
  isLoading: boolean;
  campaignStaticsList: { value: string | number; text: string }[];
}) => {
  return (
    <div
      className={styles['campaigns__statics-boxes']}
      data-single-campaign-statics-loader={isLoading}
    >
      {campaignStaticsList.map(
        (box: { value: string | number; text: string }, index: number) =>
          isLoading ? (
            <div className={styles['campaigns__statics-boxes-box']} key={`skeleton-loader-${index}`}>
              <SkeletonLoader
                noOfRows={2}
                height="84px"
                key={`skeleton-loader-${index}`}
              />
            </div>
          ) : (
            <article
              className={styles['campaigns__statics-boxes-box']}
              key={`campaign-statics-box-${box.text}-${index}`}
            >
              <h3 className={styles['campaigns__statics-boxes-box-title']}>
                {box.text}
              </h3>
              <span className={styles['campaigns__statics-boxes-box-subtitle']}>
                {box?.value || '-'}
              </span>
            </article>
          )
      )}
    </div>
  );
};

export default StaticsBoxes;
